/**
 * Détection des routes protégées (auth, rôle, permissions).
 * Source unique pour le guard, le scroll SEO et le plugin d'inactivité.
 */
export function isProtectedRouteMeta(meta = {}) {
  const perms = meta.requiresAnyPermission || meta.requiresPermissions;
  const hasPerms = Array.isArray(perms) && perms.length > 0;
  return !!(meta.requiresAuth || meta.requiresRole || hasPerms);
}

export function routeRecordIsProtected(record) {
  return isProtectedRouteMeta(record?.meta || {});
}
